// @flow
import * as React from 'react';
import styled from 'styled-components';
import Alert from './Alert';

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li:not(:first-child) {
    margin-top: 0.5rem;
  }
`;

type Props = { errors: Array<string>, className?: string };

const ErrorAlert = React.memo<Props>((props: Props) => {
  // scroll to top of page when an error occurs
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [props.errors]);

  if (props.errors.length === 0) {
    return null;
  }

  return (
    <Alert className={props.className} kind="danger">
      <List>
        {props.errors.map((error: string, index: number) => (
          <li key={index}>{error}</li>
        ))}
      </List>
    </Alert>
  );
});

export default ErrorAlert;
